import React from "react";

interface GracePeriodModalProps {
  open: boolean;
  onClose: () => void;
  onRenew?: () => void;
}

const GracePeriodModal: React.FC<GracePeriodModalProps> = ({ open, onClose, onRenew }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">
        <h2 className="text-xl font-semibold text-yellow-600 mb-2">Subscription About to expire</h2>
        <p className="text-gray-600 mb-4">
          Your subscription is about to expire. Please renew your subscription to continue performing this action.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          {onRenew && (
            <button
              onClick={onRenew}
              className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
            >
              Renew Subscription
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GracePeriodModal;